import React, { useCallback } from "react";
import axios from "axios";
import "./App.css";
import GreetingForm from "./greeting/GreetingForm";
import MazeContainer from "./maze/MazeContainer";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PromptInput from "./PromptInput";
import GameRepository from "./api-repositories/GameRepository";

const StyledBodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #00802b;
`;

const StyledWrapped = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const StyledItemWrapper = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
`;

function App() {
  const [size, setSize] = React.useState(undefined);
  const [id, setId] = React.useState(undefined);
  const [map, setMap] = React.useState(undefined);
  const [score, setScore] = React.useState(0);
  const [finished, setFinished] = React.useState(false);

  const handleGreetingData = useCallback(async (data) => {
    setSize(data);
    setFinished(false);
    try {
      const { id, gameState } = await GameRepository.postCreateNewGame(
        data.y,
        data.x
      );
      setId(id);
      setMap(gameState.map);
    } catch (error) {}
  }, []);

  const handleSendSanta = useCallback(
    async (prompt) => {
      try {
        const gameState = await GameRepository.postNextStep(id, prompt);
        gameState.forEach((frame, i) => {
          setTimeout(() => {
            setMap(frame.map);
            setScore(frame.points);
            setFinished(frame.isFinished);
          }, 1000 * i);
        });
      } catch (error) {}
    },
    [id]
  );

  //Set URL
  axios.defaults.baseURL =
    "https://dev-santa-hya-gxchdff5cqhqg7gt.westeurope-01.azurewebsites.net/";

  return (
    <StyledBodyWrapper>
      <ToastContainer />
      <StyledWrapped>
        <StyledItemWrapper>
          <GreetingForm onClick={handleGreetingData} />
        </StyledItemWrapper>
        <StyledItemWrapper>
          {id && <PromptInput onClick={handleSendSanta} />}
          {id && <h3>Your current score: {score}</h3>}
          {id && (
            <MazeContainer
              x={+size.x + 2}
              y={+size.y + 2}
              map={map}
              finished={finished}
            />
          )}
        </StyledItemWrapper>
      </StyledWrapped>

      <div className="snow">
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
        <div className="flake"></div>
      </div>
    </StyledBodyWrapper>
  );
}

export default App;
